import axios from "axios";

const API_ENDPOINT = process.env.REACT_APP_API_ENDPOINT;

const secureInstance = axios.create({
  baseURL: API_ENDPOINT,
  timeout: 30000,
});

secureInstance.interceptors.request.use(function (config) {
  const token = localStorage.getItem("token");

  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }

  return config;
});

export async function getPeople() {
  const { data } = await secureInstance.get("/people");
  return data;
}

// this is for testing the token in the header
export async function getIdentity() {
  const { data } = await secureInstance.get("/authentication/identity");
  return data;
}

export async function updatePerson(params) {
  const { data } = await secureInstance.put("/v1/person/", params);
  return data;
}

export async function createMessage(profileId, params) {
  const { data } = await secureInstance.post("/v1/message/", params);
  return data;
}

export async function getMessages() {
  const { data } = await secureInstance.get("/v1/message/");
  return data;
}

export async function getPerson() {
  const { data } = await secureInstance.get("/v1/person/");
  return data;
}

export async function getCaseCount() {
  const { data } = await secureInstance.get("/v1/eligibility/count");
  return data;
}

export async function getEligibility() {
  const { data } = await secureInstance.get("/v1/eligibility/");
  return data;
}

export async function hasSeenResults() {
  const { data } = await secureInstance.put("/v1/eligibility/");
  return data;
}

export async function sendCouponCode(params) {
  const { data } = await secureInstance.put(`/person/coupon?coupon_code=${params.coupon_code}`);
  return data;
}

export async function makePayment(params) {
  const { data } = await secureInstance.put("/person/payment", params);
  return data;
}

export async function verifyPerson(profile_id, ssn) {
  const { data } = await secureInstance.put(`/person/${profile_id}/verification?ssn=${ssn}`);
  return data;
}

// personal statement info gathering
export async function saveAnswers(question, params) {
  const { data } = await secureInstance.put(`/v1/answer/${question}`, params);
  return data;
}

export async function getAnswersAll() {
  const { data } = await secureInstance.get("/v1/answer/");
  return data;
}

export async function getAnswersByQuestion(question) {
  const { data } = await secureInstance.get(`/v1/answer/${question}`);
  return data;
}

export async function forgotPassword(params) {
  let encoded = encodeURIComponent(params.username);
  const { data } = await secureInstance.post(`/authentication/request?username=${encoded}`);
  return data;
}

export async function resetPassword(params) {
  const { data } = await secureInstance.post("/authentication/reset", params);
  return data;
}
